module.exports = __webpack_public_path__ + "assets/img/shose_nike.47d71cef.svg";